module.exports = __webpack_public_path__ + "img/map-building-highlighted.bc44110d.svg";